import { render, staticRenderFns } from "./SchoolSelect.vue?vue&type=template&id=2a032e96&scoped=true&"
import script from "./SchoolSelect.vue?vue&type=script&lang=js&"
export * from "./SchoolSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a032e96",
  null
  
)

export default component.exports